import type { Dispensados } from './regras'

// "Dispensar" da rota sem visita (decisao 3). Fica no APARELHO, como a ordem da
// rota (visitas/ordem.ts): o aviso dura um dia, nao vale fila de sync. Os ids
// sao UUID, entao a mesma chave serve a qualquer conta no aparelho.
const CHAVE = 'avisos-dispensados'

export function lerDispensados(): Dispensados | null {
  try {
    const bruto = localStorage.getItem(CHAVE)
    const lido: unknown = bruto ? JSON.parse(bruto) : null
    if (!lido || typeof lido !== 'object') return null
    const { dia, clientes } = lido as { dia?: unknown; clientes?: unknown }
    if (typeof dia !== 'string' || !Array.isArray(clientes)) return null
    return { dia, clientes: clientes.filter((id): id is string => typeof id === 'string') }
  } catch {
    return null
  }
}

export function dispensarCliente(atual: Dispensados | null, dia: string, clienteId: string): Dispensados {
  const base = atual?.dia === dia ? atual.clientes : []
  const novo = { dia, clientes: base.includes(clienteId) ? base : [...base, clienteId] }
  try { localStorage.setItem(CHAVE, JSON.stringify(novo)) } catch { /* sem localStorage: vale so nesta sessao */ }
  return novo
}
